import React from 'react'
import {useCallback, useEffect, useMemo, useState} from "react";
import associateServices from "../../services";
import CasinoListItem from "./item";
import FormButton from "../../components/form-button";
import {debounce} from 'lodash'
import InputCheckbox from "../../components/input-checkbox";
import {useTranslation} from "react-i18next";
import MobileFilter from "../../components/mobile-filter";
import SkeletonCasinoGroupGameItem from "../../components/skeleton/casino-group-item";
import {useSelector} from "react-redux";
import SearchResults from "../casino-group/search-results";
import SvgIcon from "../../components/svg-icon";
import SlimSelect from "slim-select";


const CasinoList = ({type, providersList}) => {

    const {t} = useTranslation()

    const {configuration} = useSelector(state => state.globalReducer)
    const {agent} = useSelector(state => state.globalReducer)

    const [search, setSearch] = useState('')
    const [searchProvider, setSearchProvider] = useState('')
    const [sortBy, setSortBy] = useState('sort')
    const [direction, setDirection] = useState('desc')
    const [sortByUI, setSortByUI] = useState('popular')
    const [loading, setLoading] = useState(false)

    const [sortBySelect, setSortBySelect] = useState(null)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [providers, setProviders] = useState([])

    const [providersFiltered, setProvidersFiltered] = useState([])

    const handleProviderUpdate = providerID => {
        setPage(1)
        setProviders(prevState => prevState.includes(providerID) ? prevState.filter(o => o !== providerID) : [...prevState, providerID])
    }

    const handleNextPage = () => {
        setPage(prevState => prevState + 1)
    }

    const handleResponse = (res) => {
        setLoading(false)
        res?.data?.page > 1 ? setData(prevState => [...prevState, ...res?.data?.data]) : setData(res?.data?.data)
        setTotal(res?.data?.total)
    }

    const sendRequest = useCallback((name) => {
        setLoading(true)
        associateServices.searchGames({name}).then(res => {
            setData(res?.data || [])
            setLoading(false)
        })
    }, []);

    const debouncedSendRequest = useMemo(() => {
        return debounce(sendRequest, 500);
    }, [sendRequest]);

    const onChange = (e) => {
        setSearch(e.target.value);
        debouncedSendRequest(e.target.value);
    }


    useEffect(() => {
        setPage(1)
        setData([])
        setProviders([])
    }, [type])

    useEffect(() => {
        setLoading(true)
        // const cats = ['slots', type.value]
        associateServices.getCasinoCategoryGames({
            type,
            page,
            limit: 24,
            providers,
            sortBy,
            direction
        }).then(handleResponse)

    }, [page, providers, sortBy, direction])


    useEffect(() => {
        setProvidersFiltered(providersList.filter(o => o.name?.toUpperCase().includes(searchProvider?.toUpperCase())))
    }, [providersList, searchProvider])

    useEffect(() => {
        setSortBySelect(new SlimSelect({
            select: '#sortSelect',
            showSearch: false,
            events: {
                afterChange: newVal => setSortByUI(newVal[0].value),
            }
        }))

    }, [])

    useEffect(() => {
        sortBySelect?.setSelected(sortByUI)
    }, [sortBySelect, sortByUI])

    useEffect(() => {
        setPage(1)

        if (sortByUI === 'a-z') {
            setSortBy('name')
            setDirection('asc')
        } else {
            setDirection('desc')
            if (sortByUI === 'popular')
                setSortBy('sort')

            else if (sortByUI === 'recently-added')
                setSortBy('released_at')

            else if (sortByUI === 'z-a')
                setSortBy('name')

            else if (sortByUI === 'random')
                setSortBy('random')


            else if (sortByUI === 'payout')
                setSortBy('payout')


            else if (sortByUI === 'max_multiplier')
                setSortBy('max_multiplier')
        }


    }, [sortByUI])


    return (
        <>
            {
                agent?.isMobile ?  <MobileFilter {...{
                        search,
                        onChange,
                        searchProvider,
                        setSearchProvider,
                        providers,
                        setProviders,
                        providersFiltered,
                        handleProviderUpdate,
                        setSortByUI
                    }}/>:
                    <SearchResults/>
            }


            <div className="row">

                <div className="col-12">
                    <div className="filter">
                        <button className="filter__btn" type="button">
                            <SvgIcon id={'filter'}/>
                            {t('casino.filter')}
                        </button>
                        <div className="filter__sort">
                            <span className="filter__label">
                                {t('casino.filter-by')}
                            </span>


                            <button
                                className="modal__wallet-dropdown-btn gapp2"
                                type="button"
                                id="modalWalet0"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {t('casino.provider')}
                                <SvgIcon id={'right-down'}/>
                            </button>

                            <div className="dropdown-menu modal__wallet-menu"
                                 aria-labelledby="modalWalet0">
                                <div className="modal__wallet-search">
                                    <div className="search">
                                        <input
                                            name="search"
                                            value={searchProvider}
                                            onChange={e => setSearchProvider(e.target.value)}
                                            type="text"
                                            className="search__input"
                                            placeholder={t('casino.search')}
                                        />
                                        {
                                            providers?.length >= 1 && <button
                                                onClick={e => setProviders([])}
                                                className="trade__change">
                                                <SvgIcon id={'clear'}/>
                                                {/*<span>{t('casino.clear')}</span>*/}
                                            </button>
                                        }

                                    </div>
                                </div>
                                <ul className="modal__wallet-currencies">
                                    {
                                        providersFiltered?.map(provider => (
                                            <li key={provider.id} onClick={e => e.stopPropagation()}
                                                className="provider">
                                                <InputCheckbox checked={providers.includes(provider.id)}
                                                               label={provider?.name}
                                                               badge={provider.total}
                                                               onChange={e => handleProviderUpdate(provider.id)}
                                                />
                                            </li>
                                        ))
                                    }

                                </ul>
                            </div>

                        </div>


                        <div className="filter__sort">
                            <span className="filter__label">{t('casino.sort-by')}</span>
                            <select
                                name="sortSelect"
                                id="sortSelect"
                                className="filter__select">

                                <option value={'a-z'}>{t('casino.a-z')}</option>
                                <option value={'z-a'}>{t('casino.z-a')}</option>
                                <option value={'popular'}>{t('casino.popular')}</option>
                                <option value={'recently-added'}>{t('casino.recently-added')}</option>
                                <option value={'random'}>{t('casino.random')}</option>
                                <option value={'payout'}>{t('casino.payout')}</option>
                                <option value={'max_multiplier'}>{t('casino.max_multiplier')}</option>
                            </select>
                        </div>
                        <span className="filter__amount">
                            {t('casino.total-shown', {
                                shown: data?.length,
                                total: total
                            })}
                        </span>
                    </div>
                </div>
            </div>


            <div className="row">
                {
                    loading && data?.length <= 0 ? Array.from({length: 28}).map((_, index) => (
                        <div className="col-6 col-slot" key={index}>
                            <SkeletonCasinoGroupGameItem/>
                        </div>
                    )) : data?.map((game, i) => <CasinoListItem
                        key={i}
                        index={i}
                        game={game}
                        passive={game?.blacklist?.includes(configuration.country)}
                    />)
                }
            </div>

            {
                data?.length < total && <div className="row">
                    <div className="col-12">
                        <FormButton
                            label={t('general.load-more')}
                            loading={loading}
                            disabled={loading}
                            onClick={handleNextPage}
                        />
                    </div>
                </div>
            }

        </>

    )

}

export default CasinoList
